import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../../assets/images/logo.png';
import DefaultEvent from '../../assets/images/default_event.jpg';
import Helper from '../../utility/helper';
import { useThemeState } from '../../hookState/ThemeState';
import { Typography, Link } from '@mui/material';

const useStyles = makeStyles({
    logo: {
        height: 57,
    },
    headerTilte: {
        paddingLeft: 11,
    },
    content: {
        textAlign: 'center',
        paddingTop: '100px',
        cursor: 'pointer'
    }
});
const Privacy_Policy = (props) =>
{
    const eventInfo = Helper.getStorage('eventInfo');
    const classes = useStyles();
    const themeState = useThemeState();
    useEffect(() =>
    {
        props.setLogin(false);
    }, [])
    const redirectPrivacy = () =>
    {
        window.open("https://www.nba.com/privacy-policy")
    }
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="fixed">
                    <Toolbar className={classes.headerTilte}>
                        <Box
                            component="img"
                            className={classes.logo}
                            alt="logo."
                            src={
                                !themeState.eventEnabled.value
                                    ? Logo
                                    : themeState.eventImageUrl.value != ''
                                        ? themeState.eventImageUrl.value
                                        : DefaultEvent
                            }
                        />
                        {themeState.eventEnabled.value && (
                            <Box
                                sx={{
                                    display: { xs: 'none', md: 'flex' },
                                    flexDirection: 'column',
                                    paddingLeft: 1,
                                    justifyContent: 'space-evenly',
                                    mt: '1px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontFamily="Action NBA"
                                    noWrap
                                    fontStyle="normal"
                                    fontWeight="500"
                                    fontSize={58}
                                    color="white"
                                    letterSpacing="3px"
                                    component="div">
                                    {eventInfo.eventName}
                                </Typography>
                            </Box>
                        )}

                        <Box sx={{ flexGrow: 1 }} />

                    </Toolbar>
                </AppBar>
            </Box>
            <Box className={classes.content}>
                <Link onClick={redirectPrivacy} sx={{ cursor: 'pointer' }}>
                    <Typography sx={{ fontSize: '25px' }}>NBA Privacy Policy</Typography>
                </Link>
            </Box>
        </>
    );
};
export default Privacy_Policy;
